export const mapValues = (obj, callback) => {
  const result = {};
  Object.entries(obj).forEach(_ref => {
    let [key, value] = _ref;
    result[key] = callback(value);
  });
  return result;
};
//# sourceMappingURL=mapValues.js.map